// ====================================================================
// CLIENT FOLLOW-UP CRM - SPA ROUTER & ROLE SECURITY GUARD
// ====================================================================

import { isAuthenticated, isAdmin, isStaff, getCurrentUser, logout } from './auth.js';
import { showToast, closeModal } from './ui.js';

import { renderLoginView } from './views/login.js';
import { renderDashboardView } from './views/dashboard.js';
import { renderStaffView } from './views/staff_view.js';
import { renderClientsView } from './views/clients.js';
import { renderProfileView } from './views/profile.js';
import { renderReportsView } from './views/reports.js';
import { renderUsersView } from './views/users.js';
import { renderSettingsView } from './views/settings.js';

export function initRouter() {
  window.addEventListener('hashchange', handleRoute);
  handleRoute();
}

async function handleRoute() {
  const hash = window.location.hash || '#login';
  const [route, queryString] = hash.split('?');
  const params = new URLSearchParams(queryString || '');

  const user = getCurrentUser();
  const mainContainer = document.getElementById('view-content');
  const shell = document.getElementById('app-shell');

  // Close any open modals on route change
  document.querySelectorAll('.modal-overlay').forEach(m => m.classList.remove('active'));

  // Auth Guard
  if (!isAuthenticated() && route !== '#login') {
    window.location.hash = '#login';
    return;
  }

  if (isAuthenticated() && route === '#login') {
    window.location.hash = isAdmin() ? '#dashboard' : '#staff-dashboard';
    return;
  }

  // Hide/Show Layout Shell
  if (route === '#login') {
    shell.style.display = 'none';
    const loginContainer = document.getElementById('standalone-view');
    loginContainer.style.display = 'block';
    renderLoginView(loginContainer);
    return;
  } else {
    document.getElementById('standalone-view').style.display = 'none';
    shell.style.display = 'flex';
  }

  // Role Access Restrictions (Staff cannot access admin routes)
  const adminOnlyRoutes = ['#dashboard', '#reports', '#users', '#settings'];
  if (isStaff() && adminOnlyRoutes.includes(route)) {
    showToast('Access restricted: Staff role cannot access Admin pages.', 'error');
    window.location.hash = '#staff-dashboard';
    return;
  }

  // Update Navigation Active State
  updateNavigationUI(route);

  // Render Target View
  switch (route) {
    case '#dashboard':
      await renderDashboardView(mainContainer);
      break;

    case '#staff-dashboard':
      await renderStaffView(mainContainer);
      break;

    case '#clients':
      await renderClientsView(mainContainer);
      break;

    case '#profile':
      await renderProfileView(mainContainer, params.get('id'));
      break;

    case '#reports':
      await renderReportsView(mainContainer);
      break;

    case '#users':
      await renderUsersView(mainContainer);
      break;

    case '#settings':
      renderSettingsView(mainContainer);
      break;

    default:
      window.location.hash = isAdmin() ? '#dashboard' : '#staff-dashboard';
      break;
  }
}

function updateNavigationUI(currentRoute) {
  const user = getCurrentUser();

  // Sidebar User Info
  const avatarEl = document.getElementById('sidebar-user-avatar');
  const nameEl = document.getElementById('sidebar-user-name');
  const badgeEl = document.getElementById('sidebar-user-badge');

  if (avatarEl && nameEl && badgeEl && user) {
    avatarEl.textContent = user.name ? user.name.charAt(0).toUpperCase() : 'U';
    nameEl.textContent = user.name || user.email;
    badgeEl.textContent = user.role;
    badgeEl.className = `user-role-badge ${user.role}`;
  }

  // Show/Hide Admin Nav Items
  const adminNavItems = document.querySelectorAll('.nav-admin-only');
  adminNavItems.forEach(item => {
    item.style.display = isAdmin() ? 'block' : 'none';
  });

  // Highlight active link
  document.querySelectorAll('.nav-item').forEach(item => {
    const link = item.querySelector('a');
    if (link && link.getAttribute('href') === currentRoute) {
      item.classList.add('active');
    } else {
      item.classList.remove('active');
    }
  });
}
